import {BarElement, CategoryScale, Chart, LinearScale, Title, Tooltip} from "chart.js"
import React, {useMemo} from "react"
import {Bar} from "react-chartjs-2"
import {defaultBarOptions} from "./default-options"
import {fillTopLabels} from "./chart-utils"
import {barChartPrototypes} from "../Charts/bar-chart-prototypes"
import _ from "lodash"

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip)


export const stackedBarchartPrototype = [
    {
        "key": "chartHeight",
        "type": "INTEGER",
        "label": "Chart Höhe in PX",
        "size": 6,
    },
    {
        "key": "chartWidth",
        "type": "INTEGER",
        "label": "Chart Breite in PX (default 100%)",
        "size": 6,
    },
    ...Object.values(barChartPrototypes),
]

const StackedBarchartWidget = ({widget, options, getDataFromPointer}) => {
    const pointer = useMemo(
        () => widget?.connections?.origin?.pointer,
        [widget?.connections?.origin?.pointer],
    )
    const data = getDataFromPointer(pointer)
    const tomOptions = useMemo(
        () => _.pick(widget, Object.keys(barChartPrototypes)),
        [widget],
    )
    const mergedOptions = useMemo(
        () =>
            _.merge(
                {},
                defaultBarOptions(data?.bottomLabels ?? [], tomOptions),
                options,
                data?.min ? {
                    scales: {
                        y: {
                            min: data.min,
                        },
                    },
                } : {},
            ),
        [options, data?.bottomLabels, data?.min, tomOptions],
    )

    const chartData = useMemo(
        () => ({
            labels: data?.topLabels ?? fillTopLabels(data),
            datasets: data?.datasets ?? [],
        }),
        [data],
    )

    return (
        <div style={{
            height: widget.chartHeight ? `${widget.chartHeight}px` : 300,
            width: widget.chartWidth ? `${widget.chartWidth}px` : "100%",
        }}>
            <Bar
                options={mergedOptions}
                data={chartData}
            />
        </div>
    )
}

export default StackedBarchartWidget
